module.exports = __webpack_public_path__ + "img/premiere.eb03d8b3.svg";